function MediaPlaceholder({
  label,
  ratio = '16 / 9',
  tone = 'light',
  className = '',
}) {
  const classes = ['media-placeholder', `media-placeholder--${tone}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={classes}
      style={{ aspectRatio: ratio }}
      role="img"
      aria-label={`Image placeholder: ${label}`}
    >
      <span className="media-placeholder__mark" aria-hidden="true">CVAD</span>
      <span className="media-placeholder__label">{label}</span>
      <span className="media-placeholder__ratio" aria-hidden="true">{ratio.replace(' / ', ':')}</span>
    </div>
  );
}

export default MediaPlaceholder;
